import styled, { css } from 'styled-components';
import { Button as CustomButton } from '@getinapp/appetizer';
import media from 'styled-media-query';

type InfoContentProps = {
  hasFooter: boolean;
};

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;

  background-color: rgba(0, 0, 0, 0.47);
`;

export const Layer = styled.div`
  width: 100%;
  height: 100vh;

  ${media.greaterThan('small')`
    display: flex;
    align-items: flex-start;
    justify-content: center;

    height: auto;

    padding: 4rem 0;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 100%;

  ${media.greaterThan('small')`
    max-width: 45rem;
    height: auto;

    border-radius: 1.5rem;
  `}

  background-color: rgba(244, 243, 240, 1);
`;

export const InfoContent = styled.div<InfoContentProps>`
  background-color: rgba(244, 243, 240, 1);

  padding: 2rem 3rem;

  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  ${({ hasFooter }) => css`
    ${media.greaterThan('small')`
      border-radius: ${hasFooter ? '1.5rem 1.5rem 0 0' : '1.5rem'};
    `}
  `}
`;

export const MenuButton = styled(CustomButton)`
  width: 100%;
  height: fit-content;

  a {
    text-decoration: none;

    ${({ theme }) => css`
      color: ${theme.colors.white};
    `}
  }

  ${({ theme }) => css`
    background-color: ${theme.colors.brandingMedium};
    border-color: ${theme.colors.brandingMedium};
  `}

  border-radius: 6px;

  padding: 6px 15px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => css`
    color: ${theme.colors.white};
  `}

  &:hover,
  &:focus {
    ${({ theme }) => css`
      color: ${theme.colors.white};

      background-color: ${theme.colors.brandingMedium};
      border-color: ${theme.colors.brandingMedium};
    `}
  }

  &:hover {
    filter: brightness(1.05);
  }
`;

export const WrapperContentMenuButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;

  img {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export const WrapperTextMenuButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-left: 1rem;

  span.button-title {
    ${({ theme }) => css`
      color: ${theme.colors.white};
      font-size: ${theme.font.sizes.small};
    `}
  }

  span.button-description {
    ${({ theme }) => css`
      font-size: ${theme.font.sizes.xsmall};
      font-weight: ${theme.font.normal};
      color: ${theme.colors.white};
    `}
  }
`;

export const ContainerBannerList = styled.div<{ hasBanners: boolean }>`
  ${({ hasBanners }) =>
    !hasBanners &&
    css`
      margin-top: 3rem;
    `};

  width: 100%;
  margin-bottom: 2rem;

  ${media.lessThan('large')`
    max-width: 92rem;
    min-width: 100%;
  `}
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  button {
    flex: 1;

    font-size: 1.4rem;
  }
`;

export const ShareButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  font-size: 1.2rem;
`;

export const ContentFooter = styled.div`
  width: 100%;

  ${media.lessThan('small')`
    position: fixed;
    left: 0;
    bottom: 0;
  `}
`;
